import "@babel/polyfill";
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueMaterial from 'vue-material'
import * as VueGoogleMaps from 'vue2-google-maps'
import VuePhoneNumberInput from 'vue-phone-number-input';
import VueCardFormat from 'vue-credit-card-validation';
import device from "vue-device-detector"

import 'vue-slick-carousel/dist/vue-slick-carousel.css'


//Shared Mixins
import sharedMixins from "./mixins/shared"

Vue.mixin(sharedMixins);
Vue.component('VuePhoneNumberInput', VuePhoneNumberInput);

//css
import "./scss/bootstrap.css";
import "./scss/main.scss";
import "vue2-animate/dist/vue2-animate.min.css";
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

Vue.config.productionTip = false

Vue.use(VueCardFormat);
Vue.use(device);
Vue.use(VueMaterial)
Vue.material.locale.dateFormat = 'MM/dd/yyyy'

store.commit("user/getSavedUser");
//############################################################
import VModal from 'vue-js-modal'

Vue.use(VModal, {dynamic: true, height: 'auto'});


//Base Url
axios.defaults.baseURL = 'https://ccp.mobileappsuite.com/rest';
//axios interceptor
// Add a request interceptor
axios.interceptors.request.use(function (config) {
    store.commit("shared/requestCount", 1);
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    store.commit("shared/requestCount", -1);
    return response;
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    store.commit("shared/requestCount", -1);
    if (error.response.status === 401) {
        if(router.currentRoute.name !== "Login"){
            store.commit("shared/setAlert","Your session has expired. Please login again");
            store.dispatch("user/logout");
        }
    }
    if(router.currentRoute.name === "Home"){
        if (error.response.status >= 400 && error.response.status <= 599) {
            store.commit("shared/setAlert","<h1>An unexpected error has occurred please refresh the app</h1><button onclick='window.location.reload();'>Reload</button>");
        }
    }
    return Promise.reject(error);
});


Vue.use(VueGoogleMaps, {
    load: {
        //key: 'AIzaSyB6cHL3WMnpZxqPUTaIu2SS1Fte80lwST0',
        key: 'AIzaSyBTIlgvjs1pdq8-hfUf-1bKRyYEQ7HPdws',
        libraries: 'places', // This is required if you use the Autocomplete plugin
        // OR: libraries: 'places,drawing'
        // OR: libraries: 'places,drawing,visualization'
        // (as you require)

        //// If you want to set the version, you can do so:
        // v: '3.26',
    },

    //// If you intend to programmatically custom event listener code
    //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    //// you might need to turn this on.
    // autobindAllEvents: false,

    //// If you want to manually install components, e.g.
    //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
    //// Vue.component('GmapMarker', GmapMarker)
    //// then disable the following:
    // installComponents: true,
})


const initVue = () => {
    //Init bluedot
    if (typeof au !== 'undefined') {
        window.kbluedot = au.com.bluedot
    }
    //Init vue
    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app');
}

if (window.cordova) {
    document.addEventListener('deviceready', initVue, false);
} else {
    initVue();
}
